import 'regenerator-runtime/runtime';
import Vue from '../../plugins/vueFactory';
import store from '../../store';
import wiswiseproxyclient from '../../plugins/wiswiseproxyclient';
import ShoppingCartButton from './components/shopping-cart-button.vue';

const shoppingCartButtonEl = document.getElementById('shopping-cart-button');

if (shoppingCartButtonEl) {
  const baseURL = shoppingCartButtonEl.getAttribute('data-baseurl');
  const culture = shoppingCartButtonEl.getAttribute('data-culture');
  const loggedIn = shoppingCartButtonEl.getAttribute('data-loggedin') === 'True';

  if (!baseURL || !culture)
    console.warn('Missing arguments');

  Vue.use(wiswiseproxyclient, {
    config: {
      baseURL
    }
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: shoppingCartButtonEl,
    created: function() {
      this.$store.commit('setCulture', culture);
    },
    render: h =>
      h(ShoppingCartButton, {
        props: {
          loggedIn
        }
      }),
    store
  });
}
